import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "messageContainer"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "messageContainer"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 2,
  class: "mfaContainer",
  id: "mfa-container"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { id: "downloadApp" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "stapNr" }
const _hoisted_10 = { class: "stapTitel" }
const _hoisted_11 = { class: "stapUitleg" }
const _hoisted_12 = { class: "stapUitleg" }
const _hoisted_13 = { id: "qrCode" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "stapNr" }
const _hoisted_16 = { class: "stapTitel" }
const _hoisted_17 = { class: "stapUitleg" }
const _hoisted_18 = { href: "#" }
const _hoisted_19 = {
  key: 1,
  class: "stapUitleg"
}
const _hoisted_20 = { class: "manualCode" }
const _hoisted_21 = { id: "verify" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "stapNr" }
const _hoisted_24 = { class: "stapTitel" }
const _hoisted_25 = { class: "stapUitleg" }
const _hoisted_26 = { id: "inputs" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = {
  key: 3,
  class: "mfaContainer"
}
const _hoisted_29 = {
  key: 4,
  class: "mfaContainer",
  id: "mfa-check"
}
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 5,
  class: "tooManyFailedAttemptsMessage"
}
const _hoisted_32 = ["action"]
const _hoisted_33 = ["value"]
const _hoisted_34 = ["value"]
const _hoisted_35 = ["value"]

import { ref, onMounted, nextTick, computed } from "vue"
import { useI18n } from 'vue-i18n';
import { useRouter } from "vue-router";
import { useStore } from "@/store";
import axios from "axios";
import Loader from "@pf/vue3/Loader.vue";
import ToastrComponent from "@pf/vue3/Toastr.vue";
import Checkbox from "@pf/vue3/Checkbox.vue";
import { useToastr } from "platformfrontend/ts/toastr";
import Bubble from '../components/Bubble.vue';
import MFACodeInput from 'shared/vue/MFACodeInput.vue'

const handleidingUrl = 'https://cdn.mijnlef.nl/handleidingen/MFA%20instellen%20voor%20LEF%20gebruikers.pdf';

interface MFAStatusResponse {
    IsMFAIngesteld: boolean;
    SetupCode: string | null;
    QrCodeSetupImageUrl: string | null;
    GebruikerSecret: string | null;
    RememberMeDuurInDagen: number
}

interface MFALoginResponse {
    JWT: string | null;
    ACSUrl: string | null;
    App: number;
    WachtwoordVerlopen: boolean;
    WachtwoordOngeldig: boolean;
}

interface VerifyLoginMFARequest {
    GebruikerSecret: string | null;
    Code: string | null;
    MFAToken: string | null;
    Locale: string | null;
    App: number;
    RememberMe: boolean | null;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MFACheck',
  setup(__props) {

const router = useRouter();
const store = useStore();
const i18n = useI18n();
const { t } = i18n;
const toastr = useToastr();
const loading = ref<boolean>(true);
const mfaJWT = ref<string | null>("");
const isMFAIngesteld = ref<boolean>(false);
const setupVerified = ref<boolean>(false);
const setupCode = ref<string>("");
const rememberMeDays = ref<number>(0);
const verifyAttempts = ref<number>(0);
const tooManyFailedAttempts = ref<boolean>(false);
const isButtonDisabled = ref<boolean>(false);

const wachtwoordVerlopen = ref<boolean>(false);
const wachtwoordOngeldig = ref<boolean>(false);

const showSetupCode = ref<boolean>(false);
const qrCodeSetupImageUrl = ref<string>("");
const gebruikerSecret = ref<string>("");
const mfaCode = ref<string>("");

const rememberMe = ref<boolean>(false);
const rememberMeDaysText = computed(() => {
    const aantalDagenText = rememberMeDays.value + ' ' + (rememberMeDays.value === 1 ? t('dag') : t('dagen'))
    return t('mfaVerify.rememberme', { aantalDagenText });
});

const acsForm = ref<HTMLFormElement | null>(null);
const acsPostData = ref({
    action: '',
    jwt: '' as string | null
});

onMounted(async () => {
    mfaJWT.value = store.mfaJWT.value;
    if (!mfaJWT.value) {
        router.push({ name: "login" });
        return;
    }

    await getMFAStatus();
    loading.value = false;
});

async function getMFAStatus() {
    var config = { headers: { "Content-Type": "application/json" } }
    await axios.post<MFAStatusResponse>("/api/identity/v1/mfa/login/status", mfaJWT.value, config).then(response => {
        if (response.status == 400 || response.status == 404) {
            router.push({ name: "login" });
            return;
        }

        isMFAIngesteld.value = response.data.IsMFAIngesteld
        setupCode.value = response.data.SetupCode ?? ""
        qrCodeSetupImageUrl.value = response.data.QrCodeSetupImageUrl ?? ""
        gebruikerSecret.value = response.data.GebruikerSecret ?? ""
        rememberMeDays.value = response.data.RememberMeDuurInDagen

    }).catch(() => {
        router.push({ name: "login" });
        return;
    })
}

async function verifyLoginSetupCode() {
  isButtonDisabled.value = true;

  let data = {
    Code: mfaCode.value,
    GebruikerSecret: gebruikerSecret.value,
    MFAToken: mfaJWT.value,
    Locale: i18n.locale.value,
    App: store.app.value
  } as VerifyLoginMFARequest;

  await axios.post<MFALoginResponse>("/api/identity/v1/mfa/login/setup/verify", data).then(response => {
    if (response.status == 200) {
      if (response.data.JWT && response.data.ACSUrl) {
        store.applyGrantedApp(response.data.App);
        acsPostData.value = {
          jwt: response.data.JWT,
          action: response.data.ACSUrl
        };
        setupVerified.value = true;
        verifyAttempts.value = 0; // Reset attempts on success
        setTimeout(loginSuccess, 5000); // Gebruiker doorsturen
      }
      else if (response.data.WachtwoordVerlopen || response.data.WachtwoordOngeldig) {
        wachtwoordVerlopen.value = response.data.WachtwoordVerlopen;
        wachtwoordOngeldig.value = response.data.WachtwoordOngeldig;
      }
      else if (verifyAttempts.value >= 4) {
        tooManyFailedAttempts.value = true;
        verifyAttempts.value = 0;
        isButtonDisabled.value = false;
        return;
      }
      else {
        verifyAttempts.value++;
        toastr.error(t('error.codeIncorrect'));
        isButtonDisabled.value = false;
      }
      return;
    }
    else if (response.status == 409) {
      toastr.error(t('error.mfaAlIngesteld'));
      isButtonDisabled.value = false;
      return;
    }
    else if (response.status == 400) {
      toastr.error(t('error.geenCodeIngevuld'));
      isButtonDisabled.value = false;
      return;
    }

  }).catch(error => {
    verifyAttempts.value++;
    toastr.error(t('error.codeNietGeverifieerd') + error);
    isButtonDisabled.value = false;
  });
}


async function verifyLoginCode() {
    isButtonDisabled.value = true;

    let data = { 
        Code: mfaCode.value, 
        GebruikerSecret: null, 
        MFAToken: mfaJWT.value,
        Locale: i18n.locale.value,
        App: store.app.value,
        RememberMe: rememberMe.value
    } as VerifyLoginMFARequest;

    await axios.post("/api/identity/v1/mfa/login/verify", data).then(response => {
        if (response.status == 200) {
            if (response.data.JWT && response.data.ACSUrl) {
                store.applyGrantedApp(response.data.App);
                acsPostData.value = {
                    jwt: response.data.JWT,
                    action: response.data.ACSUrl
                };
                loginSuccess();
                verifyAttempts.value = 0;
            }
            else if (response.data.WachtwoordVerlopen || response.data.WachtwoordOngeldig) {
                wachtwoordVerlopen.value = response.data.WachtwoordVerlopen;
                wachtwoordOngeldig.value = response.data.WachtwoordOngeldig;
            }
            else if (verifyAttempts.value >= 4) {
                tooManyFailedAttempts.value = true;
                verifyAttempts.value = 0;
                isButtonDisabled.value = false;
                return;
            }
            else {
                verifyAttempts.value++;
                toastr.error(t('error.codeIncorrect'));
                isButtonDisabled.value = false;
            }
            return;
        }
        else if (response.status == 400) {
            toastr.error(t('error.geenCodeIngevuld'));
            isButtonDisabled.value = false;
            return;
        }
    }).catch(error => {
        verifyAttempts.value++;
        toastr.error(t('error.codeNietGeverifieerd') + error);
        isButtonDisabled.value = false;
    });
}

function loginSuccess() {
    nextTick(() => {
        acsForm.value?.submit();
    });
}

function backToLogin() {
    router.push({ name: "login" });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createBlock(Loader, { key: 0 }))
      : (_openBlock(), _createBlock(Bubble, { key: 1 }, {
          default: _withCtx(() => [
            (wachtwoordVerlopen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  (!isMFAIngesteld.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(t)('error.mfaSuccesNoLogin')), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('error.wachtwoordVerlopen')), 1),
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('error.emailVerstuurd')), 1),
                  _createElementVNode("button", {
                    onClick: backToLogin,
                    class: "backToLogin"
                  }, _toDisplayString(_unref(t)('error.terugNaarInloggen')), 1)
                ]))
              : (wachtwoordOngeldig.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (!isMFAIngesteld.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('error.mfaSuccesNoLogin')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('error.wachtwoordOngeldig')), 1),
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('error.emailVerstuurd')), 1),
                    _createElementVNode("button", {
                      onClick: backToLogin,
                      class: "backToLogin"
                    }, _toDisplayString(_unref(t)('error.terugNaarInloggen')), 1)
                  ]))
                : (!isMFAIngesteld.value && !setupVerified.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("h2", null, _toDisplayString(_unref(t)('mfaSetup.title')), 1),
                      _createElementVNode("div", {
                        id: "intro",
                        innerHTML: _unref(t)('mfaSetup.intro', { handleidingUrl: handleidingUrl })
                      }, null, 8, _hoisted_6),
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("img", {
                          class: "stapIcon",
                          src: require('shared/assets/downloadAppIcon.svg')
                        }, null, 8, _hoisted_8),
                        _createElementVNode("p", _hoisted_9, [
                          _createTextVNode(_toDisplayString(_unref(t)('mfaSetup.stap', { nr: 1 })) + " ", 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(t)('mfaSetup.stap1.title')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)('mfaSetup.stap1.uitleg1')), 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('mfaSetup.stap1.uitleg2')), 1)
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("hr", null, null, -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("img", { src: qrCodeSetupImageUrl.value }, null, 8, _hoisted_14),
                        _createElementVNode("p", _hoisted_15, [
                          _createTextVNode(_toDisplayString(_unref(t)('mfaSetup.stap', { nr: 2 })) + " ", 1),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('mfaSetup.stap2.title')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)('mfaSetup.stap2.uitleg')), 1),
                        (!showSetupCode.value)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: "stapUitleg",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (showSetupCode.value = true))
                            }, [
                              _createElementVNode("a", _hoisted_18, _toDisplayString(_unref(t)('mfaSetup.stap2.manual')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (showSetupCode.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                              _createTextVNode(_toDisplayString(_unref(t)('mfaSetup.stap2.manualCode')) + " ", 1),
                              _createElementVNode("span", _hoisted_20, _toDisplayString(setupCode.value), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          class: "stapIcon",
                          src: require('shared/assets/enterMFACodeIcon.svg')
                        }, null, 8, _hoisted_22),
                        _createElementVNode("p", _hoisted_23, [
                          _createTextVNode(_toDisplayString(_unref(t)('mfaSetup.stap', { nr: 3 })) + " ", 1),
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('mfaSetup.stap3.title')), 1)
                        ]),
                        _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)('mfaSetup.stap3.uitleg')), 1),
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(MFACodeInput, {
                            id: "mfaCode",
                            modelValue: mfaCode.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((mfaCode).value = $event)),
                            onKeydown: _withKeys(verifyLoginSetupCode, ["enter"])
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            disabled: isButtonDisabled.value || mfaCode.value.length !== 6,
                            onClick: verifyLoginSetupCode,
                            id: "verifySetupCode"
                          }, _toDisplayString(_unref(t)('verifyCode')), 9, _hoisted_27)
                        ])
                      ])
                    ]))
                  : (!isMFAIngesteld.value && setupVerified.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("p", null, _toDisplayString(_unref(t)('mfaSetup.succes')), 1),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_unref(t)('mfaSetup.succesKlik1')) + " ", 1),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: loginSuccess
                          }, _toDisplayString(_unref(t)('mfaSetup.succesKlikHere')), 1),
                          _createTextVNode(" " + _toDisplayString(_unref(t)('mfaSetup.succesKlik2')), 1)
                        ])
                      ]))
                    : (isMFAIngesteld.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("h2", null, _toDisplayString(_unref(t)('mfaVerify.title')), 1),
                          _createElementVNode("p", null, _toDisplayString(_unref(t)('mfaVerify.text')), 1),
                          _createVNode(MFACodeInput, {
                            id: "mfaCodeCheck",
                            modelValue: mfaCode.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((mfaCode).value = $event)),
                            onKeydown: _withKeys(verifyLoginCode, ["enter"])
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("button", {
                            class: "btn btn-primary",
                            disabled: isButtonDisabled.value || mfaCode.value.length !== 6,
                            onClick: verifyLoginCode,
                            id: "verifyCode"
                          }, _toDisplayString(_unref(t)('verifyCode')), 9, _hoisted_30),
                          (rememberMeDays.value > -1)
                            ? (_openBlock(), _createBlock(Checkbox, {
                                key: 0,
                                label: rememberMeDaysText.value,
                                modelValue: rememberMe.value,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((rememberMe).value = $event)),
                                class: "rememberme"
                              }, null, 8, ["label", "modelValue"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
            (tooManyFailedAttempts.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_unref(t)('error.teVeelIncorrectePogingen')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })),
    _createElementVNode("form", {
      style: {"display":"none"},
      method: "POST",
      action: acsPostData.value.action,
      ref_key: "acsForm",
      ref: acsForm
    }, [
      _createElementVNode("input", {
        type: "hidden",
        name: "IssuedFrom",
        value: _unref(store).app.value
      }, null, 8, _hoisted_33),
      _createElementVNode("input", {
        type: "hidden",
        name: "ReturnUrl",
        value: _unref(store).returnUrl.value
      }, null, 8, _hoisted_34),
      _createElementVNode("input", {
        type: "hidden",
        name: "JWT",
        value: acsPostData.value.jwt
      }, null, 8, _hoisted_35)
    ], 8, _hoisted_32),
    _createVNode(ToastrComponent)
  ], 64))
}
}

})